import { useQuery } from '@tanstack/react-query';
import type { AlertsResponse } from '../gen/openapi';
import { useApiClient } from '../hooks/useApiClient';

export const useAlerts = () => {
  const { alerts } = useApiClient();

  return useQuery<AlertsResponse, Error>({
    queryKey: ['alerts'],
    queryFn: () => alerts.getAlertsApiV1AlertsGet(),
    staleTime: 60000, // 1 minute
    gcTime: 300000, // 5 minutes
  });
};
